import { defaultFilterData } from "../../Utils/constants";

const complaintsReducer = (
  state = {
    loading: false,
    raiseComplaintsLoading: false,
    data: null,
    totalCount: null,
    selectedComplaint: null,
    existingComplaints: null,
    offlineComplaints: [],
    filter: defaultFilterData,
    searchKey: "",
    sortBy: "desc"
  },
  action
) => {
  switch (action.type) {
    case "SET_COMPLAINTS_LOADING":
      return {
        ...state,
        loading: action.payload.loading
      };

    case "SET_RAISE_COMPLAINTS_LOADING":
      return {
        ...state,
        raiseComplaintsLoading: action.payload.loading
      };

    case "PUT_COMPLAINTS_DATA":
      return {
        ...state,
        data: action.payload.data
      };

    case "PUT_SELECTED_COMPLAINT":
      return {
        ...state,
        selectedComplaint: action.payload.data
      };

    case "PUT_FILTER":
      return {
        ...state,
        filter: action.payload.data
      };

    case "PUT_SEARCH_KEY":
      return {
        ...state,
        searchKey: action.payload.data
      };

    case "PUT_SORT_BY":
      return {
        ...state,
        sortBy: action.payload.data
      };

    case "PUT_COMPLAINTS_COUNT":
      return {
        ...state,
        totalCount: action.payload.count
      };

    case "PUT_EXISTING_COMPLAINTS":
      return {
        ...state,
        existingComplaints: action.payload.existingComplaints
      };

    case "CLEAR_EXISTING_COMPLAINT":
      return {
        ...state,
        existingComplaints: null
      };

    case "PUT_OFFLINE_COMPLAINTS":
      return {
        ...state,
        offlineComplaints: action.payload.data
      };

    case "RESET":
      return state;

    default:
      return state;
  }
};
export default complaintsReducer;
